/**
 * Role utilities for admin access control
 * 
 * Supports the 3-tier role system:
 * - super_admin: Top-level system administrator
 * - org_admin: Organization administrator
 * - admin: Legacy admin role (backward compatibility)
 * - user: Regular user (no admin access)
 */

export const ADMIN_ROLES = ["admin", "super_admin", "org_admin"];

/**
 * Check if a role has admin privileges
 * @param {string} role - The user role to check
 * @returns {boolean} True if the role is an admin role
 */
export function isAdminRole(role) {
  return ADMIN_ROLES.includes(role);
}

/**
 * Check if a role is a top-level super admin (cannot be revoked)
 * @param {string} role - The user role to check
 * @returns {boolean} True if the role is super_admin or legacy admin
 */
export function isSuperAdminRole(role) {
  return role === "super_admin" || role === "admin";
}
